import { useCallback, useMemo } from 'react'

import { EmployeeSelectorV2 } from 'modules/employees/components/EmployeeSelectorV2'
import type { EmployeeSelectorV2MultiSelectState } from 'modules/employees/components/EmployeeSelectorV2/types'
import type { SelectionMetadata } from 'modules/core/components/EntitySelectorV2/types'

type Props = {
  groupId: string
  onChange: (state: EmployeeSelectorV2MultiSelectState, metadata: SelectionMetadata) => void
  disabled?: boolean
  totalExcludedNumber?: number
}

function InviteMembersView({ groupId, onChange, disabled, totalExcludedNumber }: Props) {
  const forcedFilters = useMemo(() => {
    return {
      excludePostsGroupId: groupId,
      excludeCurrentEmployee: true,
      totalExcludedNumber,
    }
  }, [groupId, totalExcludedNumber])

  const handleEmployeeChange = useCallback(
    (state: EmployeeSelectorV2MultiSelectState, metadata: SelectionMetadata) => {
      onChange(state, metadata)
    },
    [onChange]
  )

  return (
    <EmployeeSelectorV2
      multiple
      onChange={handleEmployeeChange}
      forcedFilters={forcedFilters}
      disabled={disabled}
      options={{ disableSelectAll: false, asList: true, hideLabel: true }}
      affiliations={['employee', 'external', 'partner']}
    />
  )
}

export default InviteMembersView
